module.exports = __webpack_public_path__ + "img/tv3.153f7b05.gif";